import { Col, Space } from "antd";
import { Button } from "../../../components";
import { searchPageIcon } from "../../../svgs";
import { ExtensionLoginPageStyled } from "./extensionloginpage.styles";
import LinkButton from "../../../components/linkbutton/linkbutton";
import { checkIsFDAMode } from "../../../utils";

const ExtensionLoginPage = (props: {
  className: string;
  onLoginBtnClicked: () => void;
  onSignUpBtnClicked: (_event: any) => void;
}): JSX.Element => {
  const { className, onLoginBtnClicked, onSignUpBtnClicked } = props;
  return (
    <ExtensionLoginPageStyled className={className}>
      <Col className="a-section left-section">
        <div className="content-container">
          <div className="header">
            Welcome to DvSum Catalog Chrome Extension
          </div>

          <div className="icon-container">{searchPageIcon("101", "101")}</div>

          <div className="description">
            In order to use the extension, you need to sign into the DvSum app.
            Click on sign-in button to get started
          </div>

          <div className="login-btn-container">
            <Button className="login-btn" onClick={onLoginBtnClicked}>
              Sign In
            </Button>
          </div>

          <div className="or-text">OR</div>

          {!checkIsFDAMode() && (
            <div className="sign-up-container">
              <Space size={6} wrap align="center">
                Don't have a DvSum account?
                <LinkButton
                  className="sign-up-btn"
                  onClick={onSignUpBtnClicked}
                >
                  <u>Sign Up</u>
                </LinkButton>
              </Space>
            </div>
          )}
        </div>
      </Col>
    </ExtensionLoginPageStyled>
  );
};

export default ExtensionLoginPage;
